export function getOrderNo(order) {
  if (!order) return "N/A";
  if (order.order_no) return order.order_no;
  if (order.customer_code) return order.customer_code;
  if (order.id !== undefined && order.id !== null) return `${String(order.id).slice(0, 8)}...`;
  return "N/A";
}

export function getSystemOrderId(order) {
  if (!order?.id) return "";
  return order.id;
}
